module.exports = __webpack_public_path__ + "static/datamanagementscreen-ff0482801335d64011cfe22adc3ec272.jpg";